import React from "react";
import styles from "./PortofolioStats.module.css";
import { formatCurrency } from "../../utils";
import SkeletonCard from "../skeletons/SkeletonCard";

// --- Helpers ---
const getMonthlyLabel = () => {
  const now = new Date();
  const month = now.toLocaleString("en-US", { month: "short" });
  const year = now.getFullYear();
  return `Monthly Profit (${month} ${year})`;
};

const getWeeklyLabel = () => {
  const now = new Date();
  const day = now.getDay(); // 0 = Sun
  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(now);
  monday.setDate(now.getDate() + diffToMonday);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const format = (d) =>
    `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1
    ).padStart(2, "0")}`;

  return `Weekly Profit (${format(monday)} - ${format(sunday)})`;
};

export const PortfolioStats = ({ overview, loading }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 md:flex-row md:items-center gap-4">
      {[
        {
          label: "Aggregate Account Balance",
          value: `${formatCurrency(
            overview?.summary?.aggregate_balance_usdt || 0
          )} USDT`,
        },
        {
          label: "Total Profit",
          value: `${formatCurrency(overview?.summary?.total_profit || 0)} USDT`,
        },
        {
          label: getMonthlyLabel(), // ← updated
          value: `${formatCurrency(
            overview?.summary?.monthly_profit || 0
          )} USDT`,
        },
        {
          label: getWeeklyLabel(), // ← updated
          value: `${formatCurrency(
            overview?.summary?.weekly_profit || 0
          )} USDT`,
        },
      ].map((item, index) => (
        <div
          key={index}
          className="bg-white flex flex-col justify-center rounded-2xl px-4 py-3 shadow-sm border border-gray-200"
        >
          <p className="text-sm text-gray-500 font-normal !py-0 !m-0">
            {item.label}
          </p>

          <p className="text-2xl font-semibold text-gray-900 !py-0 !m-0 !mt-1">
            {loading ? (
              <SkeletonCard
                type="text"
                lines={2}
                widths={["0", "100px"]}
                heights={["0", "20px"]}
              />
            ) : (
              item.value
            )}
          </p>
        </div>
      ))}
    </div>
  );
};
